The conflict result for the `createWebhookSubscription` mutation.

Webhook subscriptions must have a unique combination of `eventTypeCode`, `schemeId`, `url` & `hirerId` fields.
Attempting to create a duplicate webhook subscription will result in a conflict.
